<div fxLayout="column" style=" height:250px;" class="mat-elevation-z4">

  <div fxLayout="column" fxFlexFill style="padding:15px;">
  <div fxLayout="row" class="reportCardTitle">
    Αιτήσεις
  </div>

  <div fxLayout="column" style="width:100%;">
    <div style="width:100%; font-family: 'Century Gothic', sans-serif; font-size:14px;" fxFlex fxLayoutAlign="center center">Σύνολο αιτήσεων: &nbsp;<span style="font-size:18px; font-weight: 700;">{{forms.length}}</span></div>
    <div fxLayoutAlign="space-evenly" style="height:120px; margin-top:20px;">
      <div>
        <ngx-gauge
          size="150"
          [type]="gaugeType"
                   [value]="getGDPRFormsNumber()"
                   label="GDPR αιτήσεις"
                   [thresholds]="threshold1"
                   [max]="forms.length">
        </ngx-gauge>
      </div>

      <div style="height:100px;">
        <ngx-gauge
          size="150"
          [type]="gaugeType"
          [value]="getRestFormsNumber()"
          label="Λοιπές αιτήσεις"
          [thresholds]="threshold2"
          [max]="forms.length">
        </ngx-gauge>
      </div>

      <div style="height:100px;">
        <ngx-gauge
          size="150"
          [type]="gaugeType"
          [value]="getAnnouncementFormsNumber()"
          label="Ανακοινώσεις"
          [thresholds]="threshold3"
          [max]="forms.length">
        </ngx-gauge>
      </div>
    </div>

  </div></div>


  <div fxFlexAlign="center stretch" fxLayoutAlign="end stretch">
    <button (click)="navigateToForms()" mat-raised-button style="width:100%; color:white; background-color: var(--primary);">Πλοήγηση στις αιτήσεις</button>
  </div>
</div>
